export default "__VITE_ASSET__27af9a6a__"